module.exports = __webpack_public_path__ + "live-icon.png";